<div class="chart-container h-100 w-100" [ngStyle]="chartWidgetGeneralStyle"
  [ngClass]="baseCssConfig?.borderClass !== 'none' ? baseCssConfig?.borderClass : ''">
  <!-- Header row: title + date range / layout switch controls -->
  <div class="d-flex mb-2 align-items-center" [ngStyle]="{ 'justify-content': headerAlignment }">
    <div [innerHTML]="renderTextInputHeader() | safeHtml"></div>
    <div>
      <div class="d-flex is-center gap-2">
        @if(!isFormIdMode && dataIn?.attri?.widgetProperties?.['dateRangeDropdown']){
        <div class="w-100 d-inline-block min-w-max">
          <finxone-select-dropdown [label]="''" [options]="dateRangeOptions" [selectedOption]="selectedDateRange"
            (selectionChange)="dateRangeChange($event)"></finxone-select-dropdown>
        </div>
        } @if(dataIn?.attri?.widgetProperties?.['chartLayoutSwitch']){

        <div class="w-100 d-flex"
          [ngClass]="chartLayoutSwitch?.borderClass !== 'none' ? chartLayoutSwitch?.borderClass : ''"
          [ngStyle]="getContainerStyle()">
          @for(layout of chartLayout; track layout; let i = $index) {
          <div class="p-2 w-100 is-center" [ngStyle]="getTabStyle(layout, i)"
            (click)="updateChartData(xAxisRange, layout)">
            <mat-icon [ngStyle]="chartLayoutSwitchIconStyle" [svgIcon]="getLayoutSwitchIcon(i)"></mat-icon>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Legend: TOP placement -->
  @for(pos of legendPositions; track pos) {
  @if(pos === ChartLegendPosition.TOP) {
  <div [innerHTML]="legendTemplate(pos) | safeHtml"></div>
  }
  }

  <!-- Chart canvas area -->
  <div class="w-100 h-100 position-relative" [ngStyle]="chartContentStyle">
    <!-- Circular charts (doughnut / pie / progress-arc) — used when data == Form ID -->
    @if(isCircularType) {
    <canvas #chartCanvas baseChart class="chart w-100 h-100" [data]="circularChartData" [options]="circularChartOptions"
      [type]="nativeChartType"></canvas>

    <!-- Center legend — overlaid inside the doughnut hole -->
    @for(pos of legendPositions; track pos) {
    @if(pos === ChartLegendPosition.CENTER) {
    <div [innerHTML]="legendTemplate(pos) | safeHtml"></div>
    }
    }
    } @else {
    <!-- Bar / Line chart -->
    <canvas #chartCanvas baseChart class="chart w-100 h-100" [data]="chartData" [options]="chartOptions"
      [type]="nativeChartType"></canvas>
    }
  </div>

  <!-- Legend: BOTTOM placement -->
  @for(pos of legendPositions; track pos) {
  @if(pos === ChartLegendPosition.BOTTOM) {
  <div [innerHTML]="legendTemplate(pos) | safeHtml"></div>
  }
  }
</div>